import { EmployeeSurveyDTO } from "../../models/employee-survey/employee-survey-dto";
import { EmployeeSurveySTO } from "../../models/employee-survey/employee-survey-sto";
import { BaseApiService } from "../base";

export class EmployeeSurveysApiService extends BaseApiService<EmployeeSurveyDTO, EmployeeSurveySTO> {
  constructor() {
    super({
      servicePath: "/EmployeeSurvey",
      loadItemsPath: "/GetEmployeeSurvey",
      saveItemsPath: "/SaveEmployeeSurvey",
    });
  }
}
